// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2pn_0","filesListContainer":"PosDisputesFiles_filesListContainer__1O1Bh","filesButton":"PosDisputesFiles_filesButton__bCRhF"};